module.exports = __webpack_public_path__ + "static/media/everyday_digital+weekend_papers_free_delivery2025.153c462b.webp";